import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';

import * as revealActions from '../../../actions/revealActions';
import * as accountActions from '../../../actions/accountActions';
import * as messageAlert from '../../../actions/messageAlertAction';
import ImageSelectorReveal from '../../common/reveal/ImageSelectorReveal';

export const CLASSROOM_IMAGE_SELECTOR_REVEAL = 'avatarSelectorReveal';

class ClassroomImageSelectorReveal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.uploadAsset = this.uploadAsset.bind(this);
    this.selectClassroomImage = this.selectClassroomImage.bind(this);
  }

  static propTypes = {
    newUserData: PropTypes.object,
    user: PropTypes.object,
    accountActions: PropTypes.object,
    classroomsImages: PropTypes.object,
    selectClassroomImage: PropTypes.func,
    selectedImage: PropTypes.string,
    classroomPicture: PropTypes.number,
    classroomAsset: PropTypes.string
  };

  uploadAsset(imageCrop) {
    const { selectClassroomImage } = this.props;

    return selectClassroomImage(imageCrop);
  }

  selectClassroomImage(image) {
    const { selectClassroomImage } = this.props;

    selectClassroomImage(parseInt(image, 10));
  }

  render() {
    const { classroomsImages, newUserData, selectedImage, classroomPicture, classroomAsset } = this.props;
    delete classroomsImages[10];

    return (
      <ImageSelectorReveal
        ratio={29 / 19}
        width={290}
        height={190}
        originX={80}
        originY={130}
        user={newUserData}
        images={classroomsImages}
        selectedImage={selectedImage}
        uploadAsset={this.uploadAsset}
        classroomAsset={classroomAsset}
        classroomPicture={classroomPicture}
        selectAvatarCallback={this.selectClassroomImage}
        selectingClassroomImage={true}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    classroomsImages: state.theme.images.classrooms,
    newUserData: state.account.newUserData,
    user: state.account.user,
    selectedClassroom: state.classrooms.selectedClassroom
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    revealActions: bindActionCreators(revealActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassroomImageSelectorReveal);
